import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";
import Table from "react-bootstrap/Table"; // You are using Bootstrap's Table

const VFCMembers = () => {
  const navigate = useNavigate();
  const { vfcId } = useParams();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false); // control for collapse/expand
  const Api = process.env.REACT_APP_API;

  const LOCAL_KEY = `vfcmemberDataCache_${vfcId}`;

  const saveToLocalCache = (data) => {
    const cache = {
      data,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(cache));
  };

  const loadFromLocalCache = () => {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : null;
  };

  const fetchMemberDetails = async () => {
    try {
      const config = Authorization();
      const response = await fetch(
        `${Api}/api/members/getMembersByVFC/${vfcId}`,
        config
      );
      const data = await response.json();
      setMembers(data.members);
      saveToLocalCache(data.members);
    } catch (error) {
      console.log("Error fetching members", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached?.data) {
      setMembers(cached.data);
      setLoading(false);
    } else {
      fetchMemberDetails();
    }
  }, [vfcId]);

  if (loading) return <Preloader loading={true} />;
  if (!members.length)
    return <p className="m-4 text-danger">No members found.</p>;

  const vfcName = members[0]?.vfcCode?.vfcName || "Unknown VFC";

  return (
    <div>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              setLoading(true);
              fetchMemberDetails();
            }}
          >
            🔄 Refresh Now
          </button>
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="card bg-gradient-RainforestMist card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3">VFC Members</h4>
          <h3 className="font-weight-bold">
            {members.length > 0 ? members[0].vfcCode.vfcName : "Loading..."}
          </h3>
        </div>
      </div>

      {/* Collapsible VFC group */}
      <div className="mt-3">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: "white",
            padding: "10px",
            borderRadius: "5px",
          }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <h5 className="mb-0">VFC: {vfcName}</h5>
          <span style={{ fontSize: "1.2rem" }}>{expanded ? "−" : "+"}</span>
        </div>

        {expanded && (
          <Table striped bordered hover className="mt-2">
            <thead>
              <tr>
                <th>#</th>
                <th>Member Name</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member, index) => (
                <tr key={member._id}>
                  <td>{index + 1}</td>
                  <td
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(`/drill/single/members/${member._id}`)
                    }
                  >
                    {member.name}
                  </td>

                  <td>{member.gender}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default VFCMembers;
